// Main export file for all common components
import AgencyBanner from './src/agencyBanner/agencyIndex';
import FileUpload from './src/fileUpload/index';
import Validations from './src/validations/validation';
import Validators from './src/validators/validators';
import DateFormats from './src/dateFormates/dateFormats';
import InnerLoader from './src/loader/InnerLoader';
import Page404 from './src/page404/Page404';
import DataLoader from './src/loaders/DataLoader';
import AlertPopup from './src/popups/AlertPopup';
import ConfirmPopup from './src/popups/ConfirmPopup';
import DeletePopup from './src/popups/DeletePopup';
import ImagePopup from './src/popups/ImagePopup';
import ErrorFallback from './src/popups/ErrorFallback';
import CurrencySymbol from './src/currencySymbol/index';
import ButtonCustom from './src/buttonCustom';
import CurrencyDropDown from './src/currencyDropDown/CurrencyDropDown';
import TravellerDetails from './src/travellerDetails/TravellerDetails';
// Named exports
export {
  AgencyBanner,
  FileUpload,
  Validations,
  Validators,
  DateFormats,
  InnerLoader,
  Page404,
  DataLoader,
  AlertPopup,
  ConfirmPopup,
  DeletePopup,
  ImagePopup,
  ErrorFallback,
  CurrencySymbol,
  ButtonCustom,
  CurrencyDropDown,
  TravellerDetails,
};

// Individual default exports for backward compatibility
export default {
  AgencyBanner,
  FileUpload,
  Validations,
  Validators,
  DateFormats,
  InnerLoader,
  Page404,
  DataLoader,
  AlertPopup,
  ConfirmPopup,
  DeletePopup,
  ImagePopup,
  ErrorFallback,
  CurrencySymbol,
  ButtonCustom,
  CurrencyDropDown,
  TravellerDetails,
};

export { default as AgencyBannerDefault } from './src/agencyBanner/agencyIndex';
export { default as FileUploadDefault } from './src/fileUpload/index';
export { default as ValidationsDefault } from './src/validations/validation';
export { default as ValidatorsDefault } from './src/validators/validators';
export { default as DateFormatsDefault } from './src/dateFormates/dateFormats';
export { default as InnerLoaderDefault } from './src/loader/InnerLoader';
export { default as Page404Default } from './src/page404/Page404';
export { default as DataLoaderDefault } from './src/loaders/DataLoader';
export { default as AlertPopupDefault } from './src/popups/AlertPopup';
export { default as ConfirmPopupDefault } from './src/popups/ConfirmPopup';
export { default as DeletePopupDefault } from './src/popups/DeletePopup';
export { default as ImagePopupDefault } from './src/popups/ImagePopup';
export { default as ErrorFallbackDefault } from './src/popups/ErrorFallback';
export { default as TravellerDetailsDefault } from './src/travellerDetails/TravellerDetails';

// Export individual validation functions
export {
  emailValidation,
  mobileNumberValidation,
  characterValidation,
  characternameValidation,
  spaceValidation,
  characternameUnderScoreValidation,
  characternameHypenValidation,
  characternameHypenAndSpaceValidation,
  characterNumberValidation,
  alpahnumericValidate,
  alpahnumericAndSpaceValidate,
  validatePassword,
  characterWithSomeSPL,
  panNumberValidation,
  gstNumberValidation,
  strongPassword,
  isExactMatch,
  characterNotAllowHyphenAndhash,
  alphabetAndUnderscore,
  alphabetAndComma,
  urlParamsToJSON,
} from './src/validations/validation';

// Export individual validator functions
export {
  isNotNull,
  isSuccessResponse,
  isArrayNotEmpty,
  roundToTwoDecimals,
} from './src/validators/validators';

// Export individual date format functions
export {
  calculateminutesbetweentwoDates,
  convertStringToDate,
  parseDate,
  convertTimeToYYYYMMDD,
  convertDateToYYYYMMDD,
  convertStringToYYYYMMDD,
  getTimeZoneDate,
  currentDateFormat,
  convertToLetterDate,
  convertDateToLetterDate,
  convertTimeToMin,
  isTimeAfter,
  enumerateDaysBetweenDates,
  formatTo,
  addYearsToDate,
  convertToLetterDateYYYY,
  convertToLetterDateTime,
  convertDDMMYYYYToYYYYMMDD,
  ontToOneFormat,
  convertToImageRename,
  convertLetterToDate,
  convertISTtimeZone,
  convertToDDMMYYYYHHMMSS,
  convertDateToGMT,
  convertToLetterDate24TimeFormat,
  convertToHHMM,
  convertYYYYMMDDToDDMMYYYY,
  format_date_yy_mm_dd,
  convertToDDMMWithoutSpace,
  convertToDDMM,
  convertDateToDDMMMYYY,
} from './src/dateFormates/dateFormats';
